import {
	useMutation,
	UseMutationResult,
	useQuery,
	UseQueryResult
} from '@tanstack/react-query'

//utils
import axiosInstance from './axiosInstance'
import { encrypt } from '../utils/encrypter'

//interfaces
import { QueryKeys } from './reactQuery'
import axios from 'axios'
interface ICheckuserRequest {
	email: string
}
export interface ICheckUserResponse {
	sucesso: boolean
	pre_register: boolean
	email: string
	nome?: string
	cliente_id?: string
	product_access: boolean
}

export function useCheckUser(): UseMutationResult<
	ICheckUserResponse,
	unknown,
	ICheckuserRequest
> {
	return useMutation([QueryKeys.CHECK_USER], checkUser)
}

async function checkUser(payload: ICheckuserRequest) {
	const UTMCookies = sessionStorage.getItem('UTMCookies')

	// console.log('utmcookies', UTMCookies)

	// const encrypted = encrypt({
	// 	...payload,
	// 	utm: UTMCookies
	// })

	const response = await axiosInstance.post<ICheckUserResponse>(
		'/app/checkuser',
		payload
	)

	return response.data
}

interface ILoginRequest {
	user: string
	pass: string
}
export interface ILoginResponse {
	sucesso?: boolean
	email?: string
	password?: string
	tipo_documento?: string
	documento?: string
	ins_estadual?: string
	ddi?: string
	ddd?: string
	telefone?: string
	cep?: string
	nome?: string
	endereco?: string
	complemento?: string
	bairro?: string
	cidade?: string
	numero?: string
	estado?: string
	pais?: string
	customer_id?: string
	perfil_cartao?: string
	perfil_id?: string
	perfil_quatro_ultimos?: string
	perfil_expiracao?: string
	cobranca_pagamento?: string
	produto?: string
	message?: string
	year?: number
	month?: number
	day?: number
}

interface IRecoverPasswordRequest {
	email: string
	dispatcher: EDispatcher
	produto: string
}

export enum EDispatcher {
	EMAIL = 'email'
}
interface IRecoverPasswordResponse {
	sucesso: boolean
	token_action: string
}

interface IOAuthLoginRequest {
	user: string
	vendor: EVendor
}

export enum EVendor {
	GOOGLE = 'google'
}
export interface IOAuthLoginResponse extends ILoginResponse {}

export function useOAuthLogin(): UseMutationResult<
	IOAuthLoginResponse,
	unknown,
	IOAuthLoginRequest
> {
	return useMutation([QueryKeys.OAUTH_LOGIN], OAuthLogin)
}

async function OAuthLogin(payload: IOAuthLoginRequest) {
	const encrypted = encrypt(payload)
	const response = await axiosInstance.post<IOAuthLoginResponse>(
		'/app/login-google-oauth',
		encrypted,
		{
			headers: { 'content-type': 'application/json' }
		}
	)

	return response.data
}
